module.exports = __webpack_public_path__ + "img/mindful_days_10.48ee8235.svg";